import React from 'react'
import PropTypes from 'prop-types'
import Switch from '../../../components/switch'

const SensitiveMediaButton = ({ sensitive, onSensitive }) => (
  <div className={[_s.d, _s.aiStart, _s.px5, _s.py10].join(' ')}>
    <Switch
      id="mark-sensitive"
      type="checkbox"
      checked={sensitive}
      onChange={onSensitive}
      label='Mark media as sensitive'
    />
  </div>
)

SensitiveMediaButton.propTypes = {
  sensitive: PropTypes.bool,
  disabled: PropTypes.bool,
  onSensitive: PropTypes.func.isRequired,
}

export default SensitiveMediaButton
